import {ICheckboxGroupOption} from "@pg-design/checkbox-module";

import {ApplicationSource} from "../../utils/form/application_form_source";

const propertyBaseQuestionsOptions = [
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "warunki", label: "Warunki rezerwacji i zakupu"},
    {value: "czynsz", label: "Czynsz i opłaty eksploatacyjne"},
    {value: "postoj", label: "Cenę miejsc postojowych"},
    {value: "wykon", label: "Koszt wykończenia pod klucz"},
    {value: "standard", label: "Standard wykończenia"},
    {value: "prosp", label: "Prospekt informacyjny"}
];

const propertyMoreQuestionsOptions = [
    {value: "zabez", label: "Zabezpieczenie transakcji"},
    {value: "harmon", label: "Harmonogramy płatności"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "inny", label: "Inny temat"}
];

const offerBaseQuestionsOptions = [
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "oferta_inwestycja", label: "Aktualna oferta mieszkań w tej inwestycji"},
    {value: "warunki", label: "Warunki rezerwacji i zakupu"},
    {value: "postoj", label: "Cenę miejsc postojowych"},
    {value: "wykon", label: "Możliwość wykończenia pod klucz"},
    {value: "standard", label: "Standard wykończenia"},
    {value: "prosp", label: "Prospekt informacyjny"}
];

const offerMoreQuestionsOptions = [
    {value: "zabez", label: "Zabezpieczenie transakcji"},
    {value: "harmon", label: "Harmonogramy płatności"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "inny", label: "Inny temat"}
];

const vendorBaseQuestionsOptions = [
    {value: "oferta", label: "Pełną ofertę mieszkań u dewelopera"},
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "wykon", label: "Możliwość wykończenia pod klucz"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"}
];

const vendorMoreQuestionsOptions = [
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "inny", label: "Inny temat"}
];

const toCheckboxOptions = (options: {value: string; label: string}[]): ICheckboxGroupOption[] =>
    options.map((option) => ({
        value: option.value,
        labelContent: option.label
    }));

export const propertyBaseCheckboxesOptions = toCheckboxOptions(propertyBaseQuestionsOptions);
export const propertyMoreCheckboxesOptions = toCheckboxOptions(propertyMoreQuestionsOptions);
export const offerBaseCheckboxesOptions = toCheckboxOptions(offerBaseQuestionsOptions);
export const offerMoreCheckboxesOptions = toCheckboxOptions(offerMoreQuestionsOptions);
export const vendorBaseCheckboxesOptions = toCheckboxOptions(vendorBaseQuestionsOptions);
export const vendorMoreCheckboxesOptions = toCheckboxOptions(vendorMoreQuestionsOptions);

interface ILeadFormCheckboxConfig {
    baseOptions: ICheckboxGroupOption[];
    moreOptions: ICheckboxGroupOption[];
    showAllOptions?: boolean;
}

const checkboxConfigMap: Partial<Record<ApplicationSource, ILeadFormCheckboxConfig>> = {
    [ApplicationSource.Vendor]: {
        baseOptions: vendorBaseCheckboxesOptions,
        moreOptions: vendorMoreCheckboxesOptions,
        showAllOptions: true
    },
    [ApplicationSource.Offer]: {
        baseOptions: offerBaseCheckboxesOptions,
        moreOptions: offerMoreCheckboxesOptions
    },
    [ApplicationSource.Property]: {
        baseOptions: propertyBaseCheckboxesOptions,
        moreOptions: propertyMoreCheckboxesOptions
    },
    [ApplicationSource.ApplicationOfferScheduleMeeting]: {
        baseOptions: offerBaseCheckboxesOptions,
        moreOptions: offerMoreCheckboxesOptions
    }
};

const defaultCheckboxConfig: ILeadFormCheckboxConfig = {
    baseOptions: propertyBaseCheckboxesOptions,
    moreOptions: propertyMoreCheckboxesOptions
};

export const getCheckboxConfigBySource = (source: ApplicationSource | null): ILeadFormCheckboxConfig => {
    if (source === null) {
        return defaultCheckboxConfig;
    }
    return checkboxConfigMap[source] ?? defaultCheckboxConfig;
};
import {ICheckboxGroupOption} from "@pg-design/checkbox-module";

import {ApplicationSource} from "../../utils/form/application_form_source";

const propertyBaseQuestionsOptions = [
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "warunki", label: "Warunki rezerwacji i zakupu"},
    {value: "czynsz", label: "Czynsz i opłaty eksploatacyjne"},
    {value: "postoj", label: "Cenę miejsc postojowych"},
    {value: "wykon", label: "Koszt wykończenia pod klucz"},
    {value: "standard", label: "Standard wykończenia"},
    {value: "prosp", label: "Prospekt informacyjny"}
];

const propertyMoreQuestionsOptions = [
    {value: "zabez", label: "Zabezpieczenie transakcji"},
    {value: "harmon", label: "Harmonogramy płatności"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "inny", label: "Inny temat"}
];

const offerBaseQuestionsOptions = [
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "oferta_inwestycja", label: "Aktualna oferta mieszkań w tej inwestycji"},
    {value: "warunki", label: "Warunki rezerwacji i zakupu"},
    {value: "postoj", label: "Cenę miejsc postojowych"},
    {value: "wykon", label: "Możliwość wykończenia pod klucz"},
    {value: "standard", label: "Standard wykończenia"},
    {value: "prosp", label: "Prospekt informacyjny"}
];

const offerMoreQuestionsOptions = [
    {value: "zabez", label: "Zabezpieczenie transakcji"},
    {value: "harmon", label: "Harmonogramy płatności"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "inny", label: "Inny temat"}
];

const vendorBaseQuestionsOptions = [
    {value: "oferta", label: "Pełną ofertę mieszkań u dewelopera"},
    {value: "rabat", label: "Aktualne rabaty / promocje"},
    {value: "wykon", label: "Możliwość wykończenia pod klucz"},
    {value: "kredyt", label: "Pomoc w uzyskaniu kredytu"}
];

const vendorMoreQuestionsOptions = [
    {value: "draft", label: "Draft umowy z deweloperem"},
    {value: "gwaran", label: "Gwarancję i rękojmię"},
    {value: "inny", label: "Inny temat"}
];

const toCheckboxOptions = (options: {value: string; label: string}[]): ICheckboxGroupOption[] =>
    options.map((option) => ({
        value: option.value,
        labelContent: option.label
    }));

export const propertyBaseCheckboxesOptions = toCheckboxOptions(propertyBaseQuestionsOptions);
export const propertyMoreCheckboxesOptions = toCheckboxOptions(propertyMoreQuestionsOptions);
export const offerBaseCheckboxesOptions = toCheckboxOptions(offerBaseQuestionsOptions);
export const offerMoreCheckboxesOptions = toCheckboxOptions(offerMoreQuestionsOptions);
export const vendorBaseCheckboxesOptions = toCheckboxOptions(vendorBaseQuestionsOptions);
export const vendorMoreCheckboxesOptions = toCheckboxOptions(vendorMoreQuestionsOptions);

interface ILeadFormCheckboxConfig {
    baseOptions: ICheckboxGroupOption[];
    moreOptions: ICheckboxGroupOption[];
    showAllOptions?: boolean;
}

const checkboxConfigMap: Partial<Record<ApplicationSource, ILeadFormCheckboxConfig>> = {
    [ApplicationSource.Vendor]: {
        baseOptions: vendorBaseCheckboxesOptions,
        moreOptions: vendorMoreCheckboxesOptions,
        showAllOptions: true
    },
    [ApplicationSource.Offer]: {
        baseOptions: offerBaseCheckboxesOptions,
        moreOptions: offerMoreCheckboxesOptions
    },
    [ApplicationSource.Property]: {
        baseOptions: propertyBaseCheckboxesOptions,
        moreOptions: propertyMoreCheckboxesOptions
    },
    [ApplicationSource.ApplicationOfferScheduleMeeting]: {
        baseOptions: offerBaseCheckboxesOptions,
        moreOptions: offerMoreCheckboxesOptions
    }
};

const defaultCheckboxConfig: ILeadFormCheckboxConfig = {
    baseOptions: propertyBaseCheckboxesOptions,
    moreOptions: propertyMoreCheckboxesOptions
};

export const getCheckboxConfigBySource = (source: ApplicationSource | null): ILeadFormCheckboxConfig => {
    if (source === null) {
        return defaultCheckboxConfig;
    }
    return checkboxConfigMap[source] ?? defaultCheckboxConfig;
};
